<template>
  <div class="elevation-3 mt-n2 ma-3 pa-1 pb-5">
    <v-row>
      <v-col cols="6">
        <TaxRollPayments getHeight="100" class="mt-2" />

        <div class="d-flex align-center justify-space-between">
          <p class="font-weight-light input-text-size mb-0">Delinquent Tax Records : </p>
          <v-btn
            class="input-text-size ml-2"
            small
            text
            color="primary"
            @click="handleDelinquentAction"
            :disabled="!selectedRowData || Object.keys(selectedRowData).length === 0"
          >
            Add all to Picklist
          </v-btn>
        </div>
        <TaxRollDelq class="mt-n4" />
      </v-col>
      <v-col cols="3">
        <v-textarea class="input-text-size pa-0 mb-n4 dec-line-height" rows="5"
        label="Owner Info :" readonly v-on:click.right="onRightClick" @contextmenu.prevent
        :value="ownerInfoFormatter()"/>
        <p class="font-weight-light mb-0 input-text-size pt-1 pl-1">Status Codes :</p>
        <TaxRollStatusCodes />
      </v-col>
      <v-col cols="3">
        <template v-if="checkIfThereIsMobileHome">
          <p class="font-weight-light mb-0 input-text-size pt-n1">Legal Description :</p>
          <p class="input-text-size dec-line-height" style="color: #ff0000 !important;
            font-weight: bold !important;">MOBILE HOME</p>
          <v-textarea class="input-text-size pa-0 mb-n4 mt-n3 dec-line-height" rows="3"
            readonly :value="selectedRowData.legalDesc"/>
        </template>
        <v-textarea v-else class="input-text-size mb-n5 dec-line-height" readonly
          :value="selectedRowData.legalDesc" rows="4" label="Legal Description :" />
          <div class="d-flex align-center justify-space-between">
          <span class="font-weight-light mb-0 input-text-size pt-1 pl-1">Comments : </span>
          <v-icon
            @click="addNewComments"
            color="primary"
            class="mr-4"
          >
            {{ icons.mdiPlus }}
          </v-icon>
          </div>
        <TaxRollComments />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import { mdiPlus } from '@mdi/js';
import { getWorkstationNumber } from '../../../../util/workstation-util';
import TaxRollComments from './SubComponents/TaxRollComments.vue';
import TaxRollDelq from './SubComponents/TaxRollDelq.vue';
import TaxRollPayments from './SubComponents/TaxRollPayments.vue';
import TaxRollStatusCodes from './SubComponents/TaxRollStatusCodes.vue';
import '../../../../assets/style.css';

export default {
  name: 'TaxRollFooter',
  data() {
    return {
      icons: {
        mdiPlus,
      },
    };
  },
  components: {
    TaxRollComments,
    TaxRollStatusCodes,
    TaxRollDelq,
    TaxRollPayments,
  },
  props: {
    selectedRowData: {
      type: Object,
      default: () => {},
    },
    baseCrudKey: {
      type: String,
      default: 'TaxrollTransactionList',
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'isVisible',
      'selectedTab',
      'items',
    ]),
    ...mapState({
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem,
    }),

    isVisibleProp: {
      get() {
        return this.isVisible(this.baseCrudKey);
      },
      set(value) {
        this.setIsVisible([this.baseCrudKey, value]);
      },
    },
    selectOwnerTab: {
      get() {
        return this.selectedTab(this.baseCrudKey);
      },
      set(value) {
        this.setSelectedTab([this.baseCrudKey, value]);
      },
    },
    checkIfThereIsMobileHome() {
      if (Number(this.selectedRowData.mobileHome || 0) > 0) return true;
      return false;
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setIsVisible',
      'setSelectedTab',
    ]),
    ...mapActions('tax/taxInquiryTabs', [
      'UpsertPickListSingleNMultiplipleHybrid',
      'loadTabsAdjustments',
    ]),
    ownerInfoFormatter() {
      const selectedItem = { ...this.selectedRowData };
      const arrOfKeys = [
        'name1', 'name2', 'inCareOf1', 'inCareOf2', 'address1',
        'address2', 'address3', 'address4',
      ];
      const arrOfKeysTwo = ['city', 'state', 'zip'];
      // % and C/O mean the same thing, so if address1 already leads with %, don't also print C/O.
      const addressStartsWithPercent = (selectedItem.address1 || '').trim().startsWith('%');
      const val1 = arrOfKeys.map((ft) => {
        if (ft.includes('inCareOf') && addressStartsWithPercent) return '';
        if (selectedItem[ft]) {
          if (ft.includes('inCareOf')) return `C/O ${selectedItem[ft]}\n`;
          return `${selectedItem[ft]}\n`;
        }
        return '';
      });
      const val2 = arrOfKeysTwo.map((ft) => (selectedItem[ft] ? `${selectedItem[ft]} ` : ''));
      const val3 = selectedItem.country ? `\n${selectedItem.country}` : '';
      return [...val1, ...val2, ...val3].join('');
    },
    onRightClick() {
      const selectedItem = { ...this.selectedRowData };
      if (Object.keys(selectedItem).length !== 0) {
        this.$emit('onRightClicked', selectedItem, '', true);
        this.isVisibleProp = true;
        this.selectOwnerTab = 1;
      }
    },
    addNewComments() {
      this.$emit('addNewComments');
    },
    async handleDelinquentAction() {
      const selectedItem = this.items('TaxRollDelq');
      if ((selectedItem || []).length !== 0) {
        const multipleIds = selectedItem.map((it) => it._id);
        this.wkstNumber = getWorkstationNumber();
        const pickListProfileName = localStorage.getItem('pick-list-profile-name');
        const item = {
          mutipleIds: multipleIds,
          addUnpaids: this.paymentSettingItem.loadUnpaidsAutomatically || false,
        };
        // if profile name is present then use it otherwise use workstation
        if (pickListProfileName) item.profileName = pickListProfileName;
        else item.workstation = Number(this.wkstNumber);
        await this.UpsertPickListSingleNMultiplipleHybrid({
          item,
          baseCrudKey: 'pickListTable',
        });
      }
    },
  },
};
</script>
